import { createCustomAction } from 'typesafe-actions';

import {
  standardEmptyACC,
  standardFailedACC,
  standardFlowACC,
} from '../../utils/sagas';

const REQUESTED = '$SET_MEMBER/REQUESTED';
const BLOCKED = '$SET_MEMBER/BLOCKED';
const APPROVED = '$SET_MEMBER/APPROVED';
const SUCCEEDED = '$SET_MEMBER/SUCCEEDED';
const FAILED = '$SET_MEMBER/FAILED';

const request = <T>(type: T) => {
  // prettier-ignore
  return standardFlowACC<
    T,
    {
      member?: Member;
      rawMember?: RawMember;
      supressFetchingAssociatedData?: boolean;
    }>(type);
};

export const events = {
  REQUESTED,
  BLOCKED,
  APPROVED,
  SUCCEEDED,
  FAILED,
};

export const actions = {
  requested: createCustomAction(REQUESTED, request),
  approved: createCustomAction(APPROVED, request),
  blocked: createCustomAction(BLOCKED, standardEmptyACC),
  succeeded: createCustomAction(SUCCEEDED, standardEmptyACC),
  failed: createCustomAction(FAILED, standardFailedACC),
};

export default actions.requested;
